import * as React from 'react';
import '../Login/login.scss';

import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { RouteComponentProps, Redirect } from 'react-router-dom';

import { AuthContext } from '../../contexts/AuthContext';
import { AdapterLink } from '../AdapterLink';

import SimpleSnackbar from '../SimpleSnackbar';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'wrap',
    },
    img_logo: {
      width: 350,
      marginBottom: 10,
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      marginTop: 20,
    },
    menu: {
      width: 200,
    },
    button: {
      margin: theme.spacing(1),
      marginTop: 20,
    },
    input: {
      display: 'none',
    },
  }),
);

interface IValueState {
  username: string;
  password: string;
  // email: string;
  phone: string;
  errorMessages: string[];
  usernameHasError: boolean;
  passwordHasError: boolean;
  phoneHasError: boolean;
  // emailHasError: boolean;
}

export const SignUp: React.FC<RouteComponentProps> = props => {
  const auth = React.useContext(AuthContext);
  const classes = useStyles();

  const [values, setValues] = React.useState<IValueState>({
    username: '',
    password: '',
    // email: '',
    phone: '',
    errorMessages: [],
    usernameHasError: false,
    passwordHasError: false,
    phoneHasError: false,
    // emailHasError: false
  });

  const { from } = props.location.state || { from: { pathname: '/' } };

  if (auth.hasValidSession && !auth.requireVerification) {
    return <Redirect to={from} />;
  }

  if (auth.requireVerification && !auth.hasValidSession) {
    return <Redirect to={'/verify'} />;
  }

  const validateForm = (username: string, password: string, phone: string) => {
    let err: string = '';
    if (!username && !password && !phone) {
      err = 'Please enter all fields.';
    }
    if (!username && password &&  phone) {
      err = 'Please enter email.';
    }
    if (username && !password  &&  phone) {
      err = 'Please enter password.';
    }
    /*if (username && password  &&  phone) {
      err = 'Please enter an email.';
    }*/
    if (username && password  &&  !phone) {
      err = 'Please enter phone number.';
    }

    setValues({
      ...values,
      errorMessages: [...values.errorMessages, err],
      usernameHasError: !username,
      passwordHasError: !password,
      phoneHasError: !phone,
      // emailHasError: !email
    });

    return !!username && !!password && !!phone;
  };

  const inputOnKeyDown = (e: React.KeyboardEvent<HTMLFormElement>) => {
    if (e.keyCode === 13) {  // if "Enter"
      e.preventDefault();
      handleSignUp();
    }
  };

  const handleSignUp = async () => {
    try {
      const { username, password, phone } = values;
      const inputIsValid = validateForm(username, password, phone);

      if (inputIsValid) {
        setValues({
          ...values,
          errorMessages: [],
          usernameHasError: false,
          passwordHasError: false,
          phoneHasError: false,
          // emailHasError: false
        });

        auth.signup && (await auth.signup({ username, password, phone}));
        setValues({
          ...values,
          errorMessages: ['User registered successfully. Please confirm email.'],
        });
      }
    } catch (error) {
      setValues({
        ...values,
        errorMessages: [error.message],
      });
    }
  };

  return (
    <div className="login-page">
      <div  className="login">
        <img src={require('../../assets/images/lawdroid-voice-logo.png')} alt="Lawdroid Logo" className={classes.img_logo}/>
        <form className={classes.container} noValidate autoComplete="off"  onKeyDown={inputOnKeyDown}>
          {values.errorMessages &&
            values.errorMessages.map(
              (err, i) => !!err && <SimpleSnackbar key={i} message={err} />,
            )}
          <h2>Sign Up</h2>
          <TextField
            error={values.usernameHasError}
            id="standard-name"
            placeholder="Email"
            className={classes.textField}
            value={values.username}
            onChange={e => {
              setValues({ ...values, username: e.target.value });
            }}
          />
          <TextField
            error={values.passwordHasError}
            id="standard-password"
            placeholder="Password"
            type="password"
            className={classes.textField}
            value={values.password}
            onChange={e => {
              setValues({ ...values, password: e.target.value });
            }}
          />
          <TextField
            error={values.phoneHasError}
            id="standard-phone"
            placeholder="Phone Number"
            className={classes.textField}
            value={values.phone}
            onChange={e => {
              setValues({ ...values, phone: e.target.value });
            }}
          />
          <Button
            onClick={handleSignUp}
            variant="contained"
            color="primary"
            className={classes.button}
          >
            Sign Up
          </Button>
          <div className="login-secondaryActions">
            <Button
              className={classes.button}
              component={AdapterLink}
              to="/verify"
            >
              Confirm a Code
            </Button>
            <Button
              className={classes.button}
              component={AdapterLink}
              to="/login"
            >
              Sign In
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};
